import * as createHistory from 'history';

export const history = process.env.BUILD_TARGET === 'client' ?
                       createHistory.createBrowserHistory() :
                       createHistory.createMemoryHistory();